import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from '@/app/pages/LoginPage';
import ProtectedRoute from './ProtectedRoute';
import { MobileLayout } from '@/components/layout/MobileLayout';
import DashboardPage from '@/app/pages/dashboard/DashboardPage';
import DeliveryChallansPage from '@/app/pages/deliveries/DeliveryChallansPage';
import DeliveryChallanDetailPage from '@/app/pages/deliveries/DeliveryChallanDetailPage';
import PartyDetailPage from '@/app/pages/parties/PartyDetailPage';
import ProfilePage from '@/app/pages/profile/ProfilePage';
import RecordReceiptPage from '@/app/pages/receipts/RecordReceiptPage';
import MyCollectionsPage from '@/app/pages/receipts/MyCollectionsPage';

export default function AppRouter() {
    return (
        <BrowserRouter>
            <Routes>
                {/* Public routes */}
                <Route path="/login" element={<LoginPage />} />

                {/* Protected routes with mobile layout */}
                <Route element={<ProtectedRoute />}>
                    <Route element={<MobileLayout />}>
                        <Route path="/dashboard" element={<DashboardPage />} />
                        <Route path="/deliveries" element={<DeliveryChallansPage />} />
                        <Route path="/deliveries/:id" element={<DeliveryChallanDetailPage />} />
                        <Route path="/receipts/new" element={<RecordReceiptPage />} />
                        <Route path="/collections" element={<MyCollectionsPage />} />
                        <Route path="/parties/:id" element={<PartyDetailPage />} />
                        <Route path="/profile" element={<ProfilePage />} />
                        <Route path="/settings" element={<Navigate to="/profile" replace />} />
                    </Route>
                </Route>

                {/* Default redirects */}
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
        </BrowserRouter>
    );
}
